// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1uBHm","text":"SelectPayment_text__2pDyR","title":"SelectPayment_title__28tmH","btn":"SelectPayment_btn__386fn"};